// RouteGuard.js
import { ReactNode } from "react";
import { developAxios } from "./axios.config";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import { AxiosError } from "axios";

type TRouteGuard = {
	children: ReactNode;
};

type TCardApiResponse = {
	cards: Array<{
		description: string;
		name: string;
		roles: string[];
		route: string;
		_id: string;
	}>;
};

function RouteGuard({ children }: TRouteGuard) {
	const location = useLocation();

	// List of paths to exclude from access check
	const excludedPaths = [
		"/signin",
		"/",
		"/superadmin",
		"/forbidden",
		"/studentlive",
	]; // Add any other paths you want to exclude

	const {
		data: cardData,
		isLoading,
		error,
		isError,
	} = useQuery(
		["superadmin", "cards", "view", localStorage.getItem("token")],
		() =>
			developAxios(
				localStorage.getItem("token") || ""
			).get<TCardApiResponse>("/superadmin/cards/view")
	);

	if (
		excludedPaths.includes(
			"/" + window.location.pathname.split("/")[1].toLowerCase()
		)
	) {
		return children;
	}
	if (isLoading) {
		return <div>Loading...</div>; // Or your preferred loading spinner
	}

	if (isError) {
		if ((error as AxiosError).response?.status === 401) {
			window.location.href = "/signin?redirect=" + location.pathname;
		} else {
			window.location.href = "/forbidden";
		}
	}
	if (cardData) {
		let current_route = "/" + location.pathname.split("/")[1];
		let hasAccess = false;

		let cards = cardData.data.cards;

		for (let i = 0; i < cards.length; i++) {
			if (current_route === cards[i].route) {
				hasAccess = true;
				break;
			}
		}

		if (hasAccess) return children;
		else {
			window.location.href = "/forbidden";
		}
	}

	return children;
}

export default RouteGuard;
